export default __webpack_public_path__ + "media/images/38-69dd86d835d3ad2d15148c8a5edcb290.jpg";